module.exports = __webpack_public_path__ + "b3a138bda57ae02bdecfeae18b3b3fbf.jpg";